import { useLocalSearchParams } from 'expo-router';
import EventDetailSchedules from '@/screens/EventDetailSchedules';

export default function PrivateTabsOrganizationScheduleScheduleBEventIdSchedulesRoute() {
  const { eventId } = useLocalSearchParams<{ eventId: string }>();

  return (
    <EventDetailSchedules
      basePath="/organization/schedule/(scheduleA)/[eventId]"
      eventId={eventId || ''}
    />
  );
}
